import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { deepExtract } from 'helpers/deep';
import { isObject } from 'helpers/verify';
export var InputField =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputField, _React$Component);

  function InputField() {
    _classCallCheck(this, InputField);

    return _possibleConstructorReturn(this, _getPrototypeOf(InputField).apply(this, arguments));
  }

  _createClass(InputField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          suppressErrorMessage = _this$props.suppressErrorMessage,
          suppressSuccessMessage = _this$props.suppressSuccessMessage,
          forceErrorState = _this$props.forceErrorState,
          id = _this$props.id,
          inputAttributes = _this$props.inputAttributes,
          inputClassNames = _this$props.inputClassNames,
          _this$props$inputTag = _this$props.inputTag,
          inputTag = _this$props$inputTag === void 0 ? 'input' : _this$props$inputTag,
          label = _this$props.label,
          input = _this$props.input,
          meta = _this$props.meta,
          type = _this$props.type,
          wrapperAttributes = _this$props.wrapperAttributes,
          wrapperTag = _this$props.wrapperTag,
          _this$props$isDisable = _this$props.isDisabled,
          isDisabled = _this$props$isDisable === void 0 ? false : _this$props$isDisable,
          children = _this$props.children;
      var fieldId = id || "".concat(input.name, "_field");
      var hasError = forceErrorState || meta.error && meta.touched && !meta.active;
      var classes = [];

      if (hasError) {
        classes.push('form__input--error');
      } else if (!suppressSuccessMessage && meta.touched && !meta.active && inputTag === 'input' && input.value) {
        classes.push('form__input--valid');
      }

      if (inputClassNames) {
        classes.push(inputClassNames);
      }

      if (inputAttributes && inputAttributes.onBlur) {
        var onBlurFn = inputAttributes.onBlur;

        inputAttributes.onBlur = function composedBlur(event) {
          input.onBlur(event);
          return onBlurFn.call(this, event);
        };
      }

      var firstChild = React.Children.toArray(children)[0];
      var firstChildIsOption = firstChild && firstChild.type === 'option';
      var inputElement = React.createElement(inputTag, _objectSpread({
        className: classes.join(' '),
        type: type || 'text',
        id: fieldId,
        disabled: isDisabled
      }, input, inputAttributes), firstChildIsOption && children);
      var inputAndLabelElements = [label ? React.createElement("label", {
        htmlFor: fieldId
      }, label) : null, inputElement]; // If we are a checkbox, show the input BEFORE the label

      if (inputAttributes && inputAttributes.type === 'checkbox') {
        inputAndLabelElements = [inputAndLabelElements[1], inputAndLabelElements[0]];
      }
      /* eslint-disable no-nested-ternary,indent */


      var errorElement = !hasError || forceErrorState || suppressErrorMessage ? undefined : deepExtract('error.hasHtml', meta) ? React.createElement(FormattedHTMLMessage, meta.error) : isObject(meta.error) ? React.createElement(FormattedMessage, meta.error) : meta.error;
      /* eslint-enable no-nested-ternary,indent */

      return React.createElement.apply(React, [wrapperTag || 'div', wrapperAttributes || {}].concat(_toConsumableArray(inputAndLabelElements), [errorElement ? React.createElement("div", {
        className: "error__text text--sm mt-"
      }, errorElement) : null, !firstChildIsOption && children]));
    }
  }]);

  return InputField;
}(React.Component);
InputField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  children: PropTypes.node,
  isDisabled: PropTypes.bool,
  id: PropTypes.string,
  inputClassNames: PropTypes.string,
  inputAttributes: PropTypes.object,
  inputTag: PropTypes.string,
  label: PropTypes.element,
  type: PropTypes.string,
  forceErrorState: PropTypes.bool,
  suppressErrorMessage: PropTypes.bool,
  suppressSuccessMessage: PropTypes.bool,
  wrapperAttributes: PropTypes.object,
  wrapperTag: PropTypes.string
};